import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ui-base-modal',
  template: '',
})
export class UIBaseModal<T = unknown> {
  @Input() data?: T;

  @Output() afterCloseEmitter: EventEmitter<unknown> = new EventEmitter<unknown>();

  onAfterClose(event?: unknown): void {
    this.afterCloseEmitter.emit(event);
  }
}
